exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".controls___1B7ih{position:absolute !important;bottom:20px;left:20px;z-index:10}", ""]);

// exports
exports.locals = {
	"controls": "controls___1B7ih"
};